/**
 * Configuración de las secciones del catálogo.
 *
 * La key de CATALOG_SECTIONS es el primer segmento de la URL, y tiene que
 * coincidir con los links del Header y de Category.
 *
 *   /:seccion/:brandSlug?/:productSlug?/:tab?/:solutionParam?/:docParam?
 *   /repuestos/bomag/pison-bomag-bt65/manuales
 *   /reparacion/bomag/pison-bomag-bt65/equipo/verificar-bujia-28/cambio-de-bujia-540
 *
 * `tabs` es el orden en que se muestran las secciones del acordeón del producto;
 * la primera es la que abre por defecto. Los nombres son también los valores
 * válidos del segmento :tab de la URL.
 *
 * `requires` es el contenido que un equipo tiene que tener para aparecer en los
 * selects de marca y modelo de esa sección. `null` = se muestra todo el catálogo.
 * Hoy solo 'solutions' es posible: el índice de productos de Leiten no informa
 * si un equipo tiene repuestos, kits, manuales o accesorios. Cuando lo informe,
 * es agregar el flag acá y su caso en useCatalogAvailability.
 */

export const CATALOG_SECTIONS = {
    reparacion: {
        title: 'Repará tus Equipos',
        tabs: ['equipo', 'repuestos', 'kit', 'manuales', 'accesorios'],
        requires: 'solutions',
    },
    repuestos: {
        requires: null,
        title: 'Encontra todos los Repuestos para tu Equipo',
        tabs: ['repuestos', 'equipo', 'kit', 'manuales', 'accesorios'],
    },
    kitMantenimientos: {
        requires: null,
        title: 'Encontra todos los Kit para tu Equipo',
        tabs: ['kit', 'equipo', 'repuestos', 'manuales', 'accesorios'],
    },
    accesorios: {
        requires: null,
        title: 'Encontra el Accesorio para tu Equipo',
        tabs: ['accesorios', 'equipo', 'repuestos', 'kit', 'manuales'],
    },
    manuales: {
        requires: null,
        title: 'Encontra el Manual para tu Equipo',
        tabs: ['manuales', 'equipo', 'repuestos', 'kit', 'accesorios'],
    },
};

export const CATALOG_SECTION_KEYS = Object.keys(CATALOG_SECTIONS);

// Sección por defecto cuando se busca un equipo desde el Home.
export const DEFAULT_CATALOG_SECTION = 'reparacion';

/**
 * Construye la URL del catálogo.
 *
 * Los segmentos son jerárquicos, así que el primero que falte corta la cadena:
 * un producto sin marca, o un documento sin solución, no significan nada.
 */
export function catalogPath(section, brandSlug, productSlug, tab, solutionParam, docParam) {
    const segments = [];
    for (const segment of [section, brandSlug, productSlug, tab, solutionParam, docParam]) {
        if (!segment) break;
        segments.push(segment);
    }
    return `/${segments.join('/')}`;
}
